import { render } from "./LinkPreview.vue?vue&type=template&id=66dae5b1&ts=true"
import script from "./LinkPreview.vue?vue&type=script&lang=ts"
export * from "./LinkPreview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__